<template>
  <a-layout>
    <app-header></app-header>
    <router-view></router-view>
  </a-layout>
</template>

<script>
"use strict";
import AppHeader from "@/components/partials/AppHeader";
// import AppFooter from "@/components/partials/AppFooter";
export default {
  name: "AppLayout",
  components: {
    "app-header": AppHeader,
    // "app-footer": AppFooter,
  },
  created() {},
};
</script>

<style scoped lang="scss">
.ant-layout {
  min-height: 100%;
  background-color: var(--bodyBackgroundColor);
}
</style>
